import { UPDATE_SHOW_SOCIAL_LIST_IN_EDITOR } from '../actions';

export function showSocialListInEditor(state = false, action) {
  switch (action.type) {
    case UPDATE_SHOW_SOCIAL_LIST_IN_EDITOR: {
      return action.shouldShow;
    }
    default:
      return state;
  }
}
